import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { workspacesApiRef, WorkspacesClient } from './api/WorkspacesClient';
import { rootRouteRef } from './routes';

export const awsWorkspacesPlugin = createPlugin({
  id: 'aws-workspaces',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: workspacesApiRef,
      deps: { fetchApi: fetchApiRef },
      factory: ({ fetchApi }) => new WorkspacesClient({ fetchApi }),
    }),
  ],
});

export const AwsWorkspacesPage = awsWorkspacesPlugin.provide(
  createRoutableExtension({
    name: 'AwsWorkspacesPage',
    component: () =>
      import('./components/WorkspacesPage').then(m => m.WorkspacesPage),
    mountPoint: rootRouteRef,
  }),
);
